// WidgetArea.jsx
import { faClipboard, faSearch, faThLarge, faThumbtack, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import "../../assets/scss/widgetDock.scss"; // reuse your scss
import ModalWindow from "../UI/ModalWindow";
import Container from "./WidgetModal/Container";
import swal from "sweetalert";

// Example icons from your original file - replace/add as needed
import {
    faBell,
    faBookOpen,
    faBookOpenReader,
    faBookReader,
    faCalendar,
    faChalkboard,
    faChalkboardTeacher,
    faChartLine,
    faClipboardCheck,
    faClipboardList,
    faClock,
    faComment,
    faCommentSms,
    faFileInvoiceDollar,
    faGraduationCap,
    faHandshake,
    faIdCardAlt,
    faLaptopCode,
    faSchoolCircleCheck,
    faUserGraduate,
    faUsersCog,
    faVideo
} from "@fortawesome/free-solid-svg-icons";
import AttendanceForStudent from "../Attendance/AttendanceForStudent";
import {
    checkRolePermissions,
    checkSubsTeacherPermissions,
    hrrCode,
    URL,
    userRole,
    userRoleCode
} from "../../utils/Constants";
import AcademicYearsList from "../AcademicAdministration/AcademicYears/AcademicYearsList";
import Assessment from "../AcademicAdministration/Assessment/Assessment";
import CalendarWidget from "../AcademicAdministration/Calendar/CalendarWidget";
import CalendarEventType from "../AcademicAdministration/Calendar/CalenderEventType";
import Staff from "../AcademicAdministration/EducationCommunity/Staff/Staff";
import GroupLists from "../AcademicAdministration/Groups/GroupLists";
import Groups from "../AcademicAdministration/Groups/Groups";
import Departments from "../AcademicAdministration/School/Departments/Departments";
import AddDesignation from "../AcademicAdministration/School/Designation/AddDesignation";
import Facilities from "../AcademicAdministration/School/Facilities/Facilities";
import Information from "../AcademicAdministration/School/Information/Information";
import ClassroomList from "../AcademicAdministration/SchoolGrouping/Classroom/ClassroomList";
import CreateClassroom from "../AcademicAdministration/SchoolGrouping/Classroom/CreateClassroom";
import CreateNewEducationLevel from "../AcademicAdministration/SchoolGrouping/EducationLevel/CreateNewEducationLevel";
import ListEducationLevel from "../AcademicAdministration/SchoolGrouping/EducationLevel/ListEducationLevel";
import CreateYearLevel from "../AcademicAdministration/SchoolGrouping/YearLevel/CreateYearLevel";
import ListYearLevel from "../AcademicAdministration/SchoolGrouping/YearLevel/ListYearLevel";
import BillGeneration from "../Accounting/BillGeneration";
import Category from "../Accounting/Catagory";
import DraftBills from "../Accounting/DraftBills";
import FeeConfiguration from "../Accounting/FeeConfiguration";
import AssignInventoryItems from "../Accounting/Inventory/AssignInventoryItems";
import InventoryCategory from "../Accounting/Inventory/InventoryCategory";
import InventoryItems from "../Accounting/Inventory/InventoryItems";
import StudentInventory from "../Accounting/Inventory/StudentInventory";
import Payment from "../Accounting/Payment";
import PaymentHistory from "../Accounting/PaymentHistory";
import AdmissionForm from "../Admission/Admission/AdmissionForm";
import AdmissionConfiguration from "../Admission/AdmissionConfiguration";
import AdmissionList from "../Admission/AdmissionList/AdmissionList";
import CreateSubjectAssignment from "../Assignment/CreateSubjectAssignment";
import ListSubjectAssignment from "../Assignment/ListSubjectAssignment";
import Attendance from "../Attendance/Attendance";
import AttendanceHistory from "../Attendance/AttendanceHistory";
import CreateClassRoutine from "../ClassRoutine/CreateClassRoutine";
import ListClassRoutine from "../ClassRoutine/ListClassRoutine";
import CreateCourseSyllabus from "../CoursePlan/CreateCourseSyllabus";
import ListCourseSyllabus from "../CoursePlan/ListCourseSyllabus";
import ViewExamRoutine from "../ExamRoutineList/ViewExamRoutine";
import CreateFlashCards from "../FlashCards/CreateFlashCards";
import ListFlashCards from "../FlashCards/ListFlashCards";
import CreateMCQ from "../MCQ/CreateMCQ";
import ListMCQ from "../MCQ/ListMCQ/ListMCQ";
import ListPlanner from "../Planner/ListPlanner";
import Planner from "../Planner/Planner";
import NewRecruitmentConfiguration from "../Recruitment/Academic/NewRecruitmentConfiguration";
import RecruitmentForm from "../Recruitment/Recruitment/RecruitmentForm";
import ListSchoolLMS from "../SchoolLMS/ListSchoolLMS";
import SchoolLMS from "../SchoolLMS/SchoolLMS";
import UserSetting from "../UserSetting/UserSetting";
import VideoConferencing from "../VideoConferencing/VideoConferencing";
import Worksheet from "../Worksheets/Worksheet";
import WorksheetTemplate from "../Worksheets/WorksheetTemplate";
// import ObjectiveExamForm from "../ExamModule/ObjectiveExamForm";
// import ObjectiveExamList from "../ExamModule/ObjectiveExamList";
// import SubjectiveExamForm from "../ExamModule/SubjectiveExamForm";
// import SubjectiveExamList from "../ExamModule/SubjectiveExamList";
import LeaveForStaff from "../Attendance/LeaveForStaff";
import LeaveForStudent from "../Attendance/LeaveForStudent";
import MailConfiguration from "../Attendance/MailConfiguration";
import StaffLeaveList from "../Attendance/StaffLeaveList";
import StudentLeaveList from "../Attendance/StudentLeaveList";
import CreateCards from "../Cards/CreateCards";
import ListCards from "../Cards/ListCards";
import MemoryGame from "../MemoryGame/MainModule";
import PerformanceAnalysis from "../PerformanceAnalysis/PerformanceAnalysis";
// import LeaveRequests from "../Attendance/LeaveRequests";
import { cloneDeep } from "lodash";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import letsReadLogo from "../../assets/images/logo/lets_read_logo.png";
import { ReactComponent as MeroAccountLogo } from "../../assets/images/logo/mero-accounts-logo.svg";
import { axiosPost } from "../../utils/AxiosApi";
import { getPinnedApps, pinApp, reorderApps, swapApp, unpinApp } from "../../utils/indexedDB";
import AssessmentRecordSetup from "../AssessmentRecordReport/AssessmentRecord/AssessmentRecordSetup";
import CreateAssessments from "../AssessmentRecordReport/AssessmentRecord/CreateAssessment/CreateAssessments";
import GeneralAssessmentList from "../AssessmentRecordReport/AssessmentRecord/GeneralAssessmentSettings/GeneralAssessmentList";
import ListAssessmentScale from "../AssessmentRecordReport/AssessmentRecord/ListAssessmentScale/ListAssessmentScale";
import ReportingConfiguration from "../AssessmentRecordReport/ReportingConfiguration/ReportingConfiguration";
import ReportingConfigurationList from "../AssessmentRecordReport/ReportingConfiguration/ReportingConfigurationList";
import Assessments from "../AssessmentRecordReport/ReportingSetup/ListAssessment/Assessments";
import ReportGenerator from "../AssessmentRecordReport/Reports/ReportGenerator/ReportGenerator";
import SubjectAssessment from "../AssessmentRecordReport/Reports/SubjectAssessment/SubjectAssessment";
import StudentClassroomOptionalSubjectList from "../AssessmentRecordReport/SubjectSetups/StudentClassroomOptionalSubject/StudenetClassroomOptionalSubjectList";
import StudentClassroomOptionalSubject from "../AssessmentRecordReport/SubjectSetups/StudentClassroomOptionalSubject/StudentClassroomOptionalSubject";
import SubjectAreas from "../AssessmentRecordReport/SubjectSetups/Subject Area/SubjectAreas";
import Subjects from "../AssessmentRecordReport/SubjectSetups/Subjects";
import CreateAdmitCard from "../Cards/AdmitCard/CreateAdmitCard";
import SymbolNumber from "../ConfigSymbolNumber/SymbolNumber";
import ARRCoursePlan from "../CoursePlan/ARRCoursePlan";
import Dictionary from "../Dictionary/Dictionary";
import ELibrary from "../ELibrary/ELibrary";
import ExamModuleNew from "../Exam/ExamModuleNew";
import Feedback from "../Feedbacks/Feedback";
import ListFeedback from "../Feedbacks/ListFeedback";
import LetsRead from "../LetsRead/LetsRead";
import ImportRecruitment from "../Recruitment/Recruitment/ImportRecruitment";
import ListReminder from "../Reminders/ListReminder";
import Reminder from "../Reminders/Reminder";
import ListSMSLog from "../SMS/ListSMSLog";
import SendSMS from "../SMS/SendSMS";
import TeacherMaterial from "../TeacherMaterial/TeacherMaterial";
import TechnicalSchool from "../TechnicalSchools/TechnicalSchool";
import VideoConferenceList from "../VideoConferencing/VideoConferenceList";
import { Alert } from "reactstrap";
import { Chip } from "@mui/material";
import UpdatedAllCalendar from "../AcademicAdministration/Calendar/UpdatedAllCalendar";




/**
 * WidgetArea functional component
 *
 * Props:
 * - widgets (optional) : array of widgets in the structure you used originally:
 *    [{ icon, name, contents: [{ name, code?, tabs: [{ name, code, content }] }] }, ...]
 * - pinnedCount (optional) : how many are pinned to the dock (default 5)
 * - initialPinned (optional) : array of widget names to pin in preferred order
 *
 * Notes:
 * - If you want the full original giant widget array, pass it via props (recommended)
 * - Clicking a tile opens ModalWindow and renders Container with that widget's contents
 */
const WidgetDock = (props) => {
    const { pinnedCount = 5, initialPinned = [] } = props;
    const defaultWidgets = [
        {
            icon: faBookOpenReader,
            name: "Reading Materials",
            contents: [
                {
                    name: "Reading Materials",
                    code: "reading-materials",
                    tabs: [
                        {
                            name: "Reading Materials",
                            code: "reading-materials",
                            content: <ELibrary schoolProfile={true} />,
                        },
                        {
                            name: "Dictionary",
                            code: "reading-materials",
                            content: <Dictionary />,
                        },
                        {
                            name: <img className="lets-read-logo" src={letsReadLogo} width={140} />,
                            code: "reading-materials",
                            content: <LetsRead />,
                        },
                    ],
                },
                {
                    name: "Curriculum",
                    code: "school-curriculum",
                    tabs: [
                        {
                            name: "Create Curriculum",
                            code: "create-curriculum",
                            content: <SchoolLMS lms={"curriculum"} />,
                        },
                        {
                            name: "List Curriculum",
                            code: "list-curriculum",
                            content: <ListSchoolLMS lms={"curriculum"} />,
                        },
                    ],
                },
                {
                    name: "Textbooks",
                    code: "school-textbooks",
                    tabs: [
                        {
                            name: "Create Text Books",
                            code: "create-text-books",
                            content: <SchoolLMS lms={"textbooks"} />,
                        },
                        {
                            name: "List Text Books",
                            code: "list-text-books",
                            content: <ListSchoolLMS lms={"textbooks"} />,
                        },
                    ],
                },
                {
                    name: "Question bank",
                    code: "school-question-bank",
                    tabs: [
                        {
                            name: "Create Question bank",
                            code: "create-question-bank",
                            content: <SchoolLMS lms={"question-bank"} />,
                        },
                        {
                            name: "List Question Bank",
                            code: "list-question-bank",
                            content: <ListSchoolLMS lms={"question-bank"} />,
                        },
                    ],
                },
                {
                    name: "Audio Visual Resources",
                    code: "school-av-resources",
                    tabs: [
                        {
                            name: "Create Audio Visual Resources",
                            code: "create-audio-visual",
                            content: <SchoolLMS lms={"av-resource"} />,
                        },
                        {
                            name: "List Audio Visual Resources",
                            code: "list-audio-visual",
                            content: <ListSchoolLMS lms={"av-resource"} />,
                        },
                    ],
                },
                {
                    name: "Sign Language Resources",
                    code: "sign-language-resources",
                    tabs: [
                        {
                            name: "Create Sign Language Resources",
                            code: "create-sign-language",
                            content: <SchoolLMS lms={"sign-language"} />,
                        },
                        {
                            name: "List Sign Language Resources",
                            code: "list-sign-language",
                            content: <ListSchoolLMS lms={"sign-language"} />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faGraduationCap,
            name: "Academic Administration",
            contents: [
                {
                    name: "School",
                    tabs: [
                        {
                            name: "Information",
                            code: "select-school-information",
                            content: <Information />,
                        },
                        {
                            name: "Departments",
                            code: "select-departments",
                            content: <Departments />,
                        },
                        //supressed for now as no functionality
                        // {
                        //   name: "Campuses",
                        //   code: "select-campuses",

                        //   content: <StaticCampuses />,
                        // },
                        {
                            name: "Facilities",
                            code: "select-facilities",
                            content: <Facilities />,
                        },
                        {
                            name: " Designations",
                            code: "add-designation",
                            content: <AddDesignation />,
                        },
                    ],
                },
                {
                    name: "Calendar",

                    tabs: [
                        {
                            name: "View",
                            code: "select-calendar",
                            content: (
                                <CalendarWidget
                                    assessmentModuleandEducationLevel={
                                        props.assessmentModuleandEducationLevel
                                    }
                                />
                            ),
                        },

                        {
                            name: "All Calendars",
                            code: "display-all-calendar",
                            content: <UpdatedAllCalendar />,
                        },

                        //Insert EventType(Activity)

                        {
                            name: " Insert Event Type",
                            code: "insert-event",
                            content: <CalendarEventType />,
                        },
                    ],
                },
                {
                    name: "Academic Years",
                    tabs: [
                        // {
                        //   name: "Create",
                        //   code: "insert-academic-years",
                        //   content: <AcademicYears noNavbar={true} />,
                        // },
                        {
                            name: "List",
                            code: "select-academic-years",
                            content: <AcademicYearsList />,
                        },
                    ],
                },
                {
                    name: "School Groupings",
                    tabs: [
                        {
                            name: "Create Education Level",
                            code: "insert-education-level",
                            // content: <CreateEducationLevel />
                            content: (
                                <CreateNewEducationLevel
                                    profilePeopleId={props.profilePeopleId}
                                />
                            ),
                        },
                        {
                            name: "List Education Level",
                            code: "select-education-level",
                            content: (
                                <ListEducationLevel
                                    profilePeopleId={props.profilePeopleId}
                                />
                            ),
                        },
                        {
                            name: `Create ${localStorage.getItem("yearLevel")
                                ? localStorage.getItem("yearLevel")
                                : "Grade"
                                }`,
                            code: "insert-grade",
                            content: (
                                <CreateYearLevel
                                    profilePeopleId={props.profilePeopleId}
                                />
                            ),
                        },
                        {
                            name: `List ${localStorage.getItem("yearLevel")
                                ? localStorage.getItem("yearLevel")
                                : "Grade"
                                }`,
                            code: "select-grade",
                            content: (
                                <ListYearLevel profilePeopleId={props.profilePeopleId} />
                            ),
                        },
                        //   {
                        //     name: "Assign year level",
                        //     content: <AssignYearLevel />
                        //   },
                        {
                            name: `Create ${localStorage.getItem("classroom")
                                ? localStorage.getItem("classroom")
                                : "Section"
                                }`,
                            code: "insert-section",
                            content: (
                                <CreateClassroom
                                    profilePeopleId={props.profilePeopleId}
                                />
                            ),
                        },
                        {
                            name: `List ${localStorage.getItem("classroom")
                                ? localStorage.getItem("classroom")
                                : "Section"
                                }`,
                            code: "select-section",
                            content: <ClassroomList />,
                            // content: <ListClassroom />
                        },
                        {
                            name: "Create Group",
                            code: "insert-group",
                            content: <Groups />,
                        },
                        {
                            name: "Add Group Members",
                            code: "insert-group-members",
                            content: <GroupLists members={true} />,
                        },
                        // {
                        //   name: "Assign Students",
                        //   content: <AssignStudents />
                        // },
                        // {
                        //   name: "Assigned Students",
                        //   content: <AssignedStudent />
                        // }
                    ],
                },
                {
                    name: "Assessment Module",
                    tabs: [
                        {
                            name: "Assign to Education Level",
                            code: "assign-assessment-module",
                            content: (
                                <Assessment
                                    assign={true}
                                    code="assign-assessment-module"
                                    name="Assign To Education Level"
                                />
                            ),
                        },
                        {
                            name: "List Assessment Module",
                            code: "list-assessment-module",
                            content: (
                                <Assessment
                                    assign={false}
                                    code="list-assessment-module"
                                    name="List Assessment Module"
                                />
                            ),
                        },
                    ],
                },
                {
                    name: "Education Community",
                    tabs: [
                        {
                            name: "Student",
                            code: "select-students",
                            content: <AdmissionList fromEducationCommunity={true} />,
                        },
                        {
                            name: "Staff",
                            code: "select-staffs",
                            content: <Staff fromEducationCommunity={true} />,
                        },
                    ],
                },

                // {
                //   name: "Groups",
                //   tabs: [
                //     {
                //       name: "Create Group",
                //       content: <Groups />
                //     },
                //     {
                //       name: "Add Group Members",
                //       content: <GroupLists members={true} />
                //     }
                //   ]
                // }
            ],
        },
        //New Exam Routine Module
        {
            icon: faCalendar,
            name: "Exam",
            contents: [
                {
                    name: "Exam Routine",
                    code: "school-exam-routine",
                    tabs: [
                        {
                            name: "List Exam Routine",
                            code: "list-exam-routine",
                            content: <ExamModuleNew name={"exam-module"} />,
                        },

                        {
                            name: "Symbol Number",
                            code: "create-symbol-number",
                            content: <SymbolNumber />,
                        },
                        {
                            name: "Create Admit Card",
                            code: "create-admit-card",
                            content: <CreateAdmitCard />,
                        },
                    ],
                },
            ],
        },
        //New Exam Module ends
        {
            icon: faUserGraduate,
            name: "Admission",
            contents: [
                {
                    name: "Admission",
                    tabs: [
                        {
                            name: "Admission Form",
                            content: <AdmissionForm />,
                            code: "insert-admission-form",
                        },
                        {
                            name: "Admission List",
                            content: <AdmissionList isVisible={true} />,
                            code: "select-admission-list",
                        },
                    ],
                },
                {
                    name: "Admission Configuration",
                    tabs: [
                        {
                            name: "New Configuration",
                            content: <AdmissionConfiguration />,
                            code: "insert-admission-configuration",
                        },
                    ],
                },

            ],
        },
        {
            icon: faHandshake,
            name: "Recruitment",
            contents: [
                {
                    name: "Recruitment",
                    tabs: [
                        {
                            name: "Recruitment Form",
                            code: "insert-recruitment",
                            content: <RecruitmentForm />,
                        },
                        {
                            name: "List Recruitment",
                            code: "select-recruitment",
                            content: (
                                <div>
                                    <Staff isVisible={true} />
                                </div>
                            ),
                        },
                        {
                            name: "Import Recruitment Data",
                            code: "import-recruitment",
                            content: (
                                <div>
                                    <ImportRecruitment />
                                </div>
                            ),
                        },
                    ],
                },
                {
                    name: "Recruitment Configuration",
                    tabs: [
                        {
                            name: "New Configuration",
                            code: "insert-recruitment-configuration",
                            content: (
                                <div>
                                    <NewRecruitmentConfiguration />
                                </div>
                            ),
                        },
                    ],
                },

            ],
        },
        {
            icon: faChalkboard,
            name: "Class Routine",
            contents: [
                {
                    name: "Class Routine",
                    code: "CLASS_ROU",
                    tabs: [
                        {
                            name: "Insert Class Routine",
                            code: "insert-class-routine",
                            content: <CreateClassRoutine />,
                        },
                        {
                            name: "List Class Routine",
                            code: "list-class-routine",
                            content: <ListClassRoutine />,
                        },
                    ],
                },
                {
                    name: "Exam Routine",
                    code: "EXAM_ROU",
                    tabs: [
                        {
                            name: "View Exam Routine",
                            code: "view-exam-routine",
                            content: <ViewExamRoutine />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faClock,
            name: "Attendance",
            contents: [
                {
                    name: "Student Attendance",
                    code: "create-attendance",
                    tabs: [
                        {
                            name: "Attendance",
                            code: "insert-attendance",
                            content: (
                                <div>
                                    <Attendance />
                                </div>
                            ),
                        },
                        {
                            name: "Attendance Details",
                            code: "select-attendance",
                            content: <AttendanceHistory />,
                        },
                        {
                            name: "Detail Summary ",
                            code: "attendance-detail-summary",
                            content: <AttendanceForStudent />,
                        },
                        {
                            name: "Leave",
                            code: "student-leave-request",
                            content: <LeaveForStudent />,
                        },
                        {
                            name: "Incoming Leave Requests",
                            code: "incoming-student-leave",
                            content: <StudentLeaveList />,
                        },
                    ],
                },
                {
                    name: "Staff Attendance",
                    code: "create-staff-attendance",
                    tabs: [
                        {
                            name: "Leave",
                            code: "staff-leave-request",
                            content: <LeaveForStaff />,
                        },

                        {
                            name: "Incoming Leave Requests",
                            code: "incoming-staff-leave",
                            content: <StaffLeaveList />,
                        },

                        {
                            name: "Mail Configuration",
                            code: "mail-config",
                            content: <MailConfiguration />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faVideo,
            name: "Video Conference",
            contents: [
                {
                    name: "Conference",
                    code: "conference",
                    tabs: [
                        {
                            name: "Create Conference",
                            code: "create-video-conference",
                            content: <VideoConferencing></VideoConferencing>,
                        },
                        {
                            name: "List",
                            code: "list-video-conference",
                            content: <VideoConferenceList />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faLaptopCode,
            name: "Game Based Learning",
            contents: [
                {
                    name: "MCQ",
                    code: "mcq",
                    tabs: [
                        {
                            name: "Create MCQ",
                            code: "create-mcq",
                            content: <CreateMCQ></CreateMCQ>,
                        },
                        {
                            name: "List MCQ",
                            code: "list-mcq",
                            content: <ListMCQ></ListMCQ>,
                        },
                    ],
                },
                {
                    name: "Flash Cards",
                    code: "flash-cards",
                    tabs: [
                        {
                            name: "Create Flash Cards",
                            code: "create-flash-cards",
                            content: <CreateFlashCards title="Create Flash Card Set" />,
                        },
                        {
                            name: "List Flash Cards",
                            code: "list-flash-cards",
                            content: <ListFlashCards></ListFlashCards>,
                        },
                    ],
                },
                {
                    name: "Memory Game",
                    code: "memory_game",
                    tabs: [
                        {
                            name: "Play Game",
                            code: "play_memory_game",
                            content: <MemoryGame />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faUsersCog,
            name: "User Setting",
            contents: [
                {
                    name: "User List",
                    code: "userList",
                    tabs: [
                        {
                            name: "List",
                            code: "list-user",
                            content: <UserSetting></UserSetting>,
                        },
                    ],
                },
            ],
        },
        {
            icon: faChartLine,
            name: "Performance Analysis",
            contents: [],
            role: userRoleCode.roleStudent,
            content: <PerformanceAnalysis />,
        },

        {
            icon: faBookReader,
            name: "Assignment",
            contents: [
                {
                    name: "Subject Assignment",
                    code: "SUBASMT",
                    tabs: [
                        {
                            name: "Create",
                            code: "insert-subject-assignment",
                            content: <CreateSubjectAssignment action="" />,
                        },
                        {
                            name: "List",
                            code: "list-subject-assignment",
                            content: <ListSubjectAssignment />,
                        },
                    ],
                },
            ],
        },
        //Was created for demo purpose to show the LMS separtely for MBBS college before : OFF UNTIL FURTHER NEED
        // {
        //   icon: faChalkboardTeacher,
        //   name: "LMS",
        //   contents: [
        //     {
        //       name: "Programs",
        //       code: "programs",
        //       tabs: [
        //         {
        //           name: "Create Program",
        //           code: "create-program",
        //           content: <CreateLMS></CreateLMS>,
        //         },
        //         {
        //           name: "List Programs",
        //           code: "list-programs",
        //           content: <ListLMS></ListLMS>,
        //         },
        //       ],
        //     },
        //     {
        //       name: "Courses",
        //       code: "Courses",
        //       tabs: [
        //         {
        //           name: "List Courses",
        //           code: "list-courses",
        //           content: <ListCourseModule></ListCourseModule>,
        //         },
        //       ],
        //     },
        //     {
        //       name: "Classes",
        //       code: "Classes",
        //       tabs: [
        //         {
        //           name: "List Classes",
        //           code: "list-classes",
        //           content: <ListCourseModule type="classes"></ListCourseModule>,
        //         },
        //       ],
        //     },
        //   ],
        // },

        {
            icon: faBookOpen,
            name: "Course Plan",
            contents: [
                {
                    name: "Course Syllabus",
                    code: "COUR_SYLL",
                    tabs: [
                        {
                            name: "Insert Course Syllabus",
                            code: "insert-course-syllabus",
                            content: <CreateCourseSyllabus />,
                        },
                        {
                            name: "List Course Syllabus",
                            code: "list-course-syllabus",
                            content: <ListCourseSyllabus />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faChalkboardTeacher,
            name: "Teacher Materials",
            contents: [
                {
                    name: "Teacher Materials",
                    code: "teacher-materials",
                    tabs: [
                        {
                            name: "Teacher Material",
                            code: "view-teacher-material",
                            content: <TeacherMaterial />,
                        },
                    ],
                },
                {
                    name: "Exam Routine",
                    code: "EXAM_ROU",
                    tabs: [
                        {
                            name: "View Exam Routine",
                            code: "view-exam-routine",
                            content: <ViewExamRoutine />,
                        },
                    ],
                },
            ],
        },

        // {
        //   icon: faFile,
        //   name: "Exam Routine",
        //   contents: [
        //     {
        //       name: "ExamRoutine",
        //       code: "exam_routine",
        //       tabs: [
        //         {
        //           name: "Create",
        //           code: "insert_exam_routine",
        //           content: <CreateExamRoutine />,
        //         },
        //         {
        //           name: "List",
        //           code: "list_exam_routine",
        //           content: <ListExamRoutine />,
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
            icon: faIdCardAlt,
            name: "Card and Certificates",
            contents: [
                {
                    name: "Identity Card",
                    code: "id-card",
                    tabs: [
                        {
                            name: "Create Identity Card",
                            code: "create_identity-card",
                            content: <CreateCards />,
                        },
                        {
                            name: "List Identity Card",
                            code: "list-identity-card",
                            content: <ListCards />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faFileInvoiceDollar,
            name: "Account",
            contents: [
                {
                    name: "Student Billing",
                    code: "std-bill",
                    tabs: [
                        {
                            name: "Fee Category",
                            code: "fee-category",
                            content: <Category />,
                        },
                        {
                            name: "Fee Category Configuration",
                            code: "fee-category-configuration",
                            content: <FeeConfiguration />,
                        },
                        {
                            name: "Bill Generation",
                            code: "bill-generation",
                            content: <BillGeneration />,
                        },
                        {
                            name: "Bill Drafts",
                            code: "bill-drafts",
                            content: <DraftBills />,
                        },
                        {
                            name: "Payment",
                            code: "payment",
                            content: <Payment />,
                        },
                        {
                            name: "Payment History",
                            code: "payment-history",
                            content: <PaymentHistory />,
                        },
                    ],
                },
                {
                    name: "Inventory",
                    code: "inventory",
                    tabs: [
                        {
                            name: "Inventory category",
                            code: "inventory-category",
                            content: <InventoryCategory />,
                        },
                        {
                            name: "Inventory Items",
                            code: "inventory-items",
                            content: <InventoryItems />,
                        },
                        {
                            name: "Assign Inventory Items",
                            code: "assign-inventory-items",
                            content: <AssignInventoryItems />,
                        },
                        {
                            name: "Student Inventory",
                            code: "student-inventory",
                            content: <StudentInventory />,
                        },
                    ],
                },
            ],
        },
        // this module is only added for mero accounts by creating a saperate widget in backend , the permission to make this module visible is controlled by the bill generation activity of account widget
        {
            icon: <MeroAccountLogo />,
            name: "Mero Accounts",
            contents: [
                {
                    name: "Student Billing",
                    code: "std-bill",
                    tabs: [
                        {
                            name: "Fee Category",
                            code: "fee-category",
                            content: <Category />,
                        },
                    ]
                }
            ],
        },
        {
            icon: faClipboardList,
            name: "Planner",
            contents: [
                {
                    name: "Planner",
                    code: "PLANNER",
                    tabs: [
                        {
                            name: "Insert Planner",
                            code: "insert-planner",
                            content: <Planner />,
                        },
                        {
                            name: "List Planner",
                            code: "list-planner",
                            content: <ListPlanner />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faBell,
            name: "Reminder",
            contents: [
                {
                    name: "Reminder",
                    code: "REMINDER",
                    tabs: [
                        {
                            name: "Create Reminder",
                            code: "create-reminder",
                            content: <Reminder />,
                        },
                        {
                            name: "List Reminder",
                            code: "list-reminder",
                            content: <ListReminder />,
                        },
                    ],
                },
            ],
        },
        {
            icon: faCommentSms,
            name: "SMS",
            contents: [
                {
                    name: "SMS",
                    code: "SMS",
                    tabs: [
                        {
                            name: "Send SMS",
                            // code: "send",
                            code: "send-sms",
                            content: <SendSMS />,
                        },
                        {
                            name: "SMS Log",
                            // code: "view-sms-log",
                            code: "view-sms-log",
                            content: <ListSMSLog />,
                        },
                    ],
                },
            ],
        },

        {
            icon: faSchoolCircleCheck,
            name: "Technical Schools",
            contents: [
                {
                    name: "Technical School",
                    code: "technical-school",
                    tabs: [
                        {
                            name: "Technical Schools",
                            code: "view-technical-school",
                            content: <TechnicalSchool />,
                        },
                    ],
                },
            ],
        },

        {
            icon: faComment,
            name: "Feedbacks",
            contents: [
                {
                    name: "Feedbacks",
                    code: "feedbacks",
                    tabs: [
                        {
                            name: "Feedback",
                            code: "create-feedback",
                            content: <Feedback />,
                        },
                        {
                            name: "List Feedback",
                            code: "list-feedback",
                            content: <ListFeedback />,
                        },
                    ],
                },
            ],
        },

        {
            icon: faClipboardCheck,
            name: "WorkSheets",
            contents: [
                {
                    name: "WorkSheets",
                    code: "work_sheets",
                    tabs: [
                        {
                            name: "Insert WorkSheets",
                            code: "insert_work_sheets",
                            content: <Worksheet />,
                        },
                        {
                            name: "List WorkSheets",
                            code: "list_work_sheets",
                            content: <WorksheetTemplate />,
                        },
                    ],
                },
            ],
        },
        // {
        //   icon: faCertificate,
        //   name: "Exam",
        //   contents: [
        //     {
        //       name: "Configurations",
        //       code: "exam-config",
        //       tabs: [
        //         {
        //           name: "System Exam",
        //           code: "config-system-exam",
        //           content: <SystemExamConfiguration />,
        //         },
        //         {
        //           name: "Question Paper",
        //           code: "config-question-paper",
        //           content: <SystemExamConfiguration />,
        //         },
        //       ],
        //     },
        //     {
        //       name: "Examination",
        //       code: "exam-exam",
        //       tabs: [
        //         {
        //           name: "Take Exam",
        //           code: "exam-take",
        //           content: <ExamForm />,
        //         },
        //         {
        //           name: "Check Exam",
        //           code: "exam-check",
        //           content: <SystemExamAssessment />,
        //         },
        //       ],
        //     },
        //   ],
        // },
    ]
    const arrModules = [
        { component: SubjectAreas, create: true, name: "Create Subject Area" },
        { component: SubjectAreas, create: false, name: "List Subject Areas" },
        { component: Subjects, create: true, name: "Create Subject" },
        { component: Subjects, create: false, name: "List Subjects" },
        { component: ARRCoursePlan, create: false, name: "View Course Plan" },

        {
            component: StudentClassroomOptionalSubject,
            create: false,
            name: "Assign Student Optional Subjects",
        },
        {
            component: StudentClassroomOptionalSubjectList,
            create: false,
            name: "List Student Optional Subjects",
        },
        {
            component: AssessmentRecordSetup,
            name: "Create Assessment Scale",
        },
        {
            component: ListAssessmentScale,
            name: "List Assessment Scale",
        },
        {
            component: CreateAssessments,
            name: "Create Assessment",
        },
        { component: Assessments, name: "List Assessment" },
        {
            component: ReportingConfiguration,
            name: "Create Report Format",
        },
        {
            component: ReportingConfigurationList,
            name: "List Report Formats",
        },
        {
            component: SubjectAssessment,
            name: "Subject Assessment",
        },
        {
            component: GeneralAssessmentList,
            name: "General Assessment",
        },
        {
            component: ReportGenerator,
            name: "Publish Assessment Report",
        },
    ]
    const templateARR = {
        icon: faClipboard,
        name: "ARR NAME",
        contents: [
            {
                name: "Subjects Setup",
                tabs: [
                    {
                        name: "Create Subject Area",
                        code: "insert-subject-area",
                        content: (
                            <SubjectAreas create={true} code="ARR CODE" name="ARR NAME" />
                        ),
                    },
                    {
                        name: "List Subject Areas",
                        code: "select-subject-area",
                        content: (
                            <SubjectAreas create={false} code="ARR CODE" name="ARR NAME" />
                        ),
                    },
                    {
                        name: "Create Subject",
                        code: "insert-subject",
                        content: (
                            <Subjects
                                create={true}
                                code="ARR CODE"
                                name="ARR NAME"
                                profilePeopleId={props.profilePeopleId}
                            />
                        ),
                    },
                    {
                        name: "List Subjects",
                        code: "select-subject",
                        content: (
                            <Subjects create={false} code="ARR CODE" name="ARR NAME" />
                        ),
                    },
                    {
                        name: "Assign Student Optional Subjects",
                        code: "insert-student-optional-subjects",
                        content: (
                            <StudentClassroomOptionalSubject
                                create={false}
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                    {
                        name: "List Student Optional Subjects",
                        code: "select-student-optional-subjects",
                        content: (
                            <StudentClassroomOptionalSubjectList
                                create={false}
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                    {
                        name: "View Course Plan",
                        code: "view_arr_course_plan",
                        content: (
                            <ARRCoursePlan
                                name="Higher Secondary ARR"
                                code={hrrCode.code}
                            />
                        ),
                    },
                ],
            },
            {
                name: "Recording Setup",
                tabs: [
                    {
                        name: "Create Assessment Scale",
                        code: "insert-assessment-scale",
                        content: (
                            <AssessmentRecordSetup
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                    {
                        name: "List Assessment Scale",
                        code: "select-assessment-scale",
                        content: (
                            <ListAssessmentScale
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                    {
                        name: "Create Assessment",
                        code: "insert-assessment",
                        content: (
                            <CreateAssessments
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                    {
                        name: "List Assessment",
                        code: "select-assessment",
                        content: (
                            <Assessments code={hrrCode.code} name="Higher Secondary ARR" />
                        ),
                    },
                ],
            },
            {
                name: "Reporting Setup",
                tabs: [
                    {
                        name: "Create Report Format",
                        code: "insert-report-format",
                        content: (
                            <ReportingConfiguration
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                    {
                        name: "List Report Formats",
                        code: "select-report-format",
                        content: (
                            <ReportingConfigurationList
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                ],
            },
            {
                name: "Recording",
                tabs: [
                    {
                        name: "Subject Assessment",
                        code: "select-subject-assessment",
                        content: (
                            <SubjectAssessment
                                code={hrrCode.code}
                                name="Higher Secondary ARR"
                            />
                        ),
                    },
                    {
                        name: "General Assessment",
                        code: "select-general-assessment",
                        content: (
                            <GeneralAssessmentList
                                name="Higher Secondary ARR"
                                code={hrrCode.code}
                            />
                        ),
                    },
                ],
            },
            {
                name: "Reports",
                tabs: [
                    {
                        name: "Publish Assessment Report",
                        code: "publish-assessment-report",
                        content: (
                            <ReportGenerator
                                name="Higher Secondary ARR"
                                code={hrrCode.code}
                            />
                        ),
                    },
                ],
            },
        ],
    }
    const apps = [
        { name: "Academic Administration", code: "ACA_ADMIN" },
        { name: "Admission", code: "ADM_ADMIN" },
        { name: "Recruitment", code: "REC_ADMIN" },
        { name: "Attendance", code: "ATD_ADMIN" },
        { name: "Profile Picture", code: "PP_ADMIN" },
        { name: "Academic Repository", code: "ACA_REPO_ADMIN" },
        { name: "Account", code: "ACC_ADMIN" },
        // { name: "Academic Repository", code: "ACA_REPO_ADMIN" },
        // { name: "Academic Repository", code: "ACA_REPO_ADMIN" },
        // { name: "Academic Repository", code: "ACA_REPO_ADMIN" },
    ]
    const [pinnedApps, setPinnedApps] = useState([]);
    // modal state for the macOS Launchpad
    const [launchpadOpen, setLaunchpadOpen] = useState(false);
    // widget modal (when a widget is opened)
    const [widgetModalOpen, setWidgetModalOpen] = useState(false);
    const [activeWidgetIndex, setActiveWidgetIndex] = useState(null);
    const [modalTitle, setModalTitle] = useState("");
    // Use prop widgets when provided, otherwise default.

    const [pinned, setPinned] = useState([]);
    const [widgets, setWidgets] = useState(defaultWidgets);
    const [assessmentModules, setAssessmentModules] = useState([]);
    const MAX_PINNED = 8;
    const peopleId = localStorage.getItem("peopleId");


    // search input for launchpad
    const [searchQuery, setSearchQuery] = useState("");
    
    useEffect(() => {
        getAssessmentModules();
        getAppAdmins();
        (async () => {
            const pinned = await getPinnedApps(peopleId);
            setPinnedApps(pinned.map(app => app.name));
        })();
    }, []);

    const getAppAdmins = () => {
        let newApps = [...apps];
        let param = apps.map(function (app) {
                return { subRoleCode: app.code };
            })
        axiosPost(
            URL.getUserSubRolesBySubRoleCode,
            param ,
            (response) => {
                newApps.forEach((newApp) => {
                    newApp.userSubRoles = response?.data?.data;
                    let newUserSubRoles = newApp.userSubRoles?.map((userSubRole) => {
                        return {
                            value: userSubRole.userId,
                            label: userSubRole.name,
                        };
                    });
                    newApp.userSubRoles = newUserSubRoles;
                    newApp.userSubRolesForDelete = newUserSubRoles;
                });
            }
        );
        // });
    };


    const permittedWidgets = useMemo(() => {
        if (!widgets) return [];
        // Filter widgets based on permissions and optional search query
        const allowedWidgets = widgets
            .filter((w) =>
            (checkRolePermissions(w.name, "widgets") ||
                checkSubsTeacherPermissions(w.name, "widgets"))
            )
            .map((w) => {
                // Filter contents and tabs based on activity permissions
                return {
                    ...w,
                    contents: w.contents?.filter((c) =>
                        checkRolePermissions(c.name, "modules", w.name) ||
                        checkSubsTeacherPermissions(c.name, "modules", w.name)
                    )
                        .map((c) => {
                            return {
                                ...c,
                                tabs: c.tabs?.filter((t) =>
                                    checkRolePermissions(t.code, "activity", w.name) ||
                                    checkSubsTeacherPermissions(t.code, "activity", w.name)
                                ) ?? []
                            };
                        }) ?? []
                }
            });
        allowedWidgets.forEach((w) => {
            w.name =
                (userRole === userRoleCode.roleStudent ||
                    userRole === userRoleCode.roleStudentContact) &&
                    w.name === "Academic Administration"
                    ? "The School"
                    : w.name === "Reading Materials"
                        ? "E-Library"
                        : w.name;
        });

        return allowedWidgets;
    }, [widgets]);

    const filteredWidgets = useMemo(() => {
        if (!searchQuery) return permittedWidgets;
        return permittedWidgets.filter(w =>
            w.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [permittedWidgets, searchQuery]);


        useEffect(() => {
            populateWidgetsByAssessmentModules()
        }, [assessmentModules])

    const populateWidgetsByAssessmentModules = () => {
       
        let newWidgets = [...widgets],
            newApps = [...apps],
            insertIndex = 2;
        if (assessmentModules.length > 0) {
            for (let i = 0; i < assessmentModules.length; i++) {
                let aModule = assessmentModules[i];
                let newARRTemplate = cloneDeep(templateARR);
                newARRTemplate.name = aModule.name;
                let newAppsTemplate = {
                    name: aModule.name,
                    code: `${aModule.code}_ADMIN`,
                };
                newARRTemplate.contents.forEach((content) => {
                    content.tabs.forEach((tab, tabIndex) => {
                        const arrModuleIndex = arrModules.findIndex(
                            (arrmodule) => arrmodule.name === tab.name
                        );
                        if (arrModuleIndex !== -1) {
                            const arrmodule = arrModules[arrModuleIndex];
                            if (arrmodule.create !== null && arrmodule.create !== undefined) {
                                tab.content = (
                                    <arrmodule.component
                                        create={arrmodule.create}
                                        code={aModule.code}
                                        name={aModule.name}
                                        profilePeopleId={props.profilePeopleId}
                                    />
                                );
                            } else {
                                tab.content = (
                                    <arrmodule.component
                                        code={aModule.code}
                                        name={aModule.name}
                                        profilePeopleId={props.profilePeopleId}
                                    />
                                );
                            }
                        }
                    });
                });
                newWidgets.splice(insertIndex, 0, newARRTemplate);
                newApps.splice(insertIndex, 0, newAppsTemplate);
                insertIndex++;
            }
        }
        setWidgets(newWidgets )
    };

    const getAssessmentModules = () => {
        
        axiosPost(
            URL.getAssesmentModules,
            {},
            (response) => {
                
                if (response.status === 200) {
                     setAssessmentModules(response.data.data);
                    populateWidgetsByAssessmentModules()
                }
            },(err) =>{
                
            }
        );
    };

    const openWidget = useCallback((index) => {
        setTimeout(() => {
            setActiveWidgetIndex(index);
            setWidgetModalOpen(true);
        }, 100);
        setLaunchpadOpen(false)
    }, []);

    const closeWidgetModal = useCallback(() => {
        setWidgetModalOpen(false);
        setActiveWidgetIndex(null);
        setSearchQuery("")
    }, []);

    const toggleLaunchpad = () => {
        setLaunchpadOpen(!launchpadOpen);
    };

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") {
                if (launchpadOpen) setLaunchpadOpen(false);
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [launchpadOpen]);

    const renderIcon = (icon) => {
        if (!icon) return null;
        if (React.isValidElement(icon)) {
            return React.cloneElement(icon, { className: "tt-widget-fontAwesome-icon" });
        }
        return <FontAwesomeIcon icon={icon} className="tt-widget-fontAwesome-icon" />;
    };

    const onTileClick = (widget) => {
        if(widget?.name === 'Mero Accounts'){
            let param = {
                "access-token": localStorage.getItem("token"),
                "refresh-token": localStorage.getItem("refreshToken"),
            }

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = URL.meroAccountSSOLogin;
            form.target = '_blank'; // Open in new tab

            for (const key in param) {
                if (param.hasOwnProperty(key)) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = param[key];
                    form.appendChild(input);
                }
            }

            // 3. Append to document and submit
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
            return
        }
        
        const idx = filteredWidgets?.findIndex((w) => w.name === widget.name);
        setModalTitle(widget?.name);
        if (idx !== -1) openWidget(idx);
    };

    useEffect(() => {
        // if (!propsWidgets) return;
        const allWidgets = filteredWidgets;
        console.log('batman')

        const userPinnedWidgets = pinnedApps
            .map(name => allWidgets.find(w => w.name === name))
            .filter(Boolean);

        let dockWidgets = [...userPinnedWidgets];

        if (dockWidgets.length < pinnedCount) {
            for (const w of allWidgets) {
                if (!dockWidgets.find(p => p.name === w.name)) {
                    dockWidgets.push(w);
                }
                if (dockWidgets.length >= pinnedCount) break;
            }
        }

        setPinned(dockWidgets);
    }, [pinnedApps, pinnedCount, widgets]);



    const handlePinToggle = async (e, app) => {
        e.stopPropagation();
        if(!app) return
        if (pinnedApps.includes(app?.name)) {
            await unpinApp(peopleId, app?.name);
            setPinnedApps(p => p.filter(name => name !== app?.name));
        } else {
            if (pinnedApps.length >= MAX_PINNED){return (
                swal({
                    title: "Oops!",
                    text: `You can pin up to ${MAX_PINNED} apps only.`,
                    allowOutsideClick: true,
                    closeOnClickOutside: true,
                })
            )}
            
            // <Alert severity="warning">You can pin up to {MAX_PINNED} apps only.</Alert>;
            await pinApp(pinnedApps.length, peopleId,app.name);
            setPinnedApps(p => [...p, app.name]);
        }
    };

    const handleDragEnd = async (result) => {
        const { source, destination } = result;

        if (!destination) return;

        const pinned = [...pinnedApps];
        const unpinned = filteredWidgets.filter(w => !pinned.includes(w.name));

        // Reorder within Pinned
        if (source.droppableId === "pinned" && destination.droppableId === "pinned") {
            
            const [moved] = pinned.splice(source.index, 1);
            pinned.splice(destination.index, 0, moved);
            setPinnedApps(pinned);
            // await swapApp(source.index,destination.index,peopleId);
            await pinApp(destination.index,peopleId,moved)
            return;
        }

        // Move from Apps → Pinned
        if (source.droppableId === "apps" && destination.droppableId === "pinned") {
            if (pinnedApps.length >= MAX_PINNED){return (
                swal({
                    title: "Oops!",
                    text: `You can pin up to ${MAX_PINNED} apps only.`,
                    allowOutsideClick: true,
                    closeOnClickOutside: true,
                })
            )}
            const movedWidget = unpinned[source.index];
            pinned.splice(destination.index, 0, movedWidget.name);

            setPinnedApps(pinned);
            await pinApp(destination.index,peopleId,movedWidget.name);
            return;
        }

        // Move from Pinned → Apps (unpin)
        if (source.droppableId === "pinned" && destination.droppableId === "apps") {
            const [removed] = pinned.splice(source.index, 1);
            setPinnedApps(pinned);
             await unpinApp(peopleId, removed);
            return;
            }

    };



    // Renderers
    const Dock = () => (
        <>
                <div className="dock-container" >
                    <div className="dock-widgets" aria-hidden={false}>
                        {/* Add a search tile to quickly open launchpad search */}
                        <div className="tt-widget-holder-dock search-shortcut" onClick={() => toggleLaunchpad()} title="All Apps">
                            <div className="tt-widget-icon">
                                <FontAwesomeIcon icon={faThLarge} className="tt-widget-fontAwesome-icon" />
                            </div>
                            <div className="tt-widget-title">All Apps</div>
                        </div>
                        {pinned.map((w, i) => (
                            <div key={w.name + i} className="tt-widget-holder-dock" onClick={() => onTileClick(w)} data-tip={w.name}>
                                <div className="tt-widget-icon">{renderIcon(w.icon)}</div>
                                <div className="tt-widget-title">{w.name}</div>
                            </div>
                        ))}
                    </div>

                    <ReactTooltip />
                </div>
        </>
    );

    const Launchpad = () => {
        if (!launchpadOpen) return null;
        return (
            <div className="launchpad-overlay" role="dialog" aria-modal="true">
                <div className="launchpad-panel">
                    <div className="launchpad-header">
                        <div className="launchpad-search">
                            <FontAwesomeIcon icon={faSearch} />
                            <input
                                aria-label="Search widgets and modules"
                                placeholder="Search widgets or modules..."
                                value={searchQuery}
                                onChange={(e) => {
                                    e.stopPropagation()
                                    setSearchQuery(e.target.value)}
                                }
                                autoFocus
                            />
                        </div>
                        <button className="launchpad-close" onClick={() => toggleLaunchpad()} title="Close">
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    {
                        searchQuery == "" ? <>
                            <DragDropContext onDragEnd={handleDragEnd}>
                                <div className="widget-pin-label">
                                    <Chip label={(pinnedApps.length > 0) ?
                                        <>Pinned</>
                                        : <>Click pin icon (<FontAwesomeIcon icon={faThumbtack} />) to pin them.</>
                                    }/>
                                    
                                </div>
                                <Droppable droppableId="pinned" direction="horizontal">
                                    {(provided) => (
                                        <div className="launchpad-grid" ref={provided.innerRef} {...provided.droppableProps}>
                                            {
                                                (pinnedApps.length <= 0) &&
                                                <div className="launchpad-tile no-hover">Empty</div>
                                            }
                                            {(
                                                pinnedApps.map((name, idx) => {
                                                    const w = filteredWidgets.find(x => x.name === name);
                                                    if (!w) return <></>;
                                                    return <Draggable key={w.name} draggableId={w.name} index={idx}>
                                                        {(provided) =>
                                                        (<div className="launchpad-tile" onClick={() => onTileClick(w)} ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}>
                                                            <div className="launchpad-icon">{renderIcon(w.icon)}
                                                                <button
                                                                    className={'pin-button  pinned'}
                                                                    onClick={(e) => handlePinToggle(e, w)}
                                                                >
                                                                    <FontAwesomeIcon icon={faThumbtack} />
                                                                </button>
                                                            </div>
                                                            <div className="laun//chpad-name">{w.name}</div>
                                                        </div>)}
                                                    </Draggable>
                                                })
                                            )}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                                <div className="widget-pin-label"> <Chip label={'Apps'} /></div>
                                <Droppable droppableId="apps" direction="horizontal">
                                    {(provided) => (
                                        <div className="launchpad-grid" ref={provided.innerRef}
                                            {...provided.droppableProps}>
                                            {filteredWidgets.length === 0 ? (
                                                <div className="launchpad-empty">No widgets found</div>
                                            ) : (
                                                filteredWidgets.filter(w => !pinnedApps.includes(w.name)).map((w, idx) => (
                                                    <Draggable key={w.name} draggableId={w.name} index={idx}>
                                                        {(provided) =>
                                                            <div key={w.name + idx} className="launchpad-tile" onClick={() => onTileClick(w)} ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}>
                                                                <div className="launchpad-icon">{renderIcon(w.icon)}
                                                                    <button
                                                                        className={'pin-button'}
                                                                        onClick={(e) => handlePinToggle(e, w)}
                                                                    >
                                                                        <FontAwesomeIcon icon={faThumbtack} />
                                                                    </button>
                                                                </div>
                                                                <div className="laun//chpad-name">{w.name}</div>
                                                            </div>
                                                        }
                                                    </Draggable>
                                                ))
                                            )}
                                            {provided.placeholder}
                                        </div>)}
                                </Droppable>
                            </DragDropContext>
                        </>
                            :
                            <div className="launchpad-grid">
                                {
                                    (filteredWidgets.length <= 0) &&
                                    <div className="launchpad-tile no-hover">Not found</div>
                                }
                                {(
                                    filteredWidgets.map((w, idx) => (
                                        (<div key={w.name + idx} className="launchpad-tile" onClick={() => onTileClick(w)}>
                                            <div className="launchpad-icon">{renderIcon(w.icon)}
                                            </div>
                                            <div className="laun//chpad-name">{w.name}</div>
                                        </div>)
                                    ))
                                )}
                            </div>
                    }
                </div>
            </div>
        );
    };

    // Compose modal body using your Container component
    const WidgetModalBody = () => {
        
        if (activeWidgetIndex === null || !filteredWidgets[activeWidgetIndex]) return null;
        const widget = filteredWidgets[activeWidgetIndex];
        return <Container contents={widget.contents || []} name={widget.name} content={widget.content || null} />;
    };

    return (
        <>
            {/* Dock */}
            <div className="widget-area-wrapper">
                <Dock />
            </div>

            {/* Launchpad modal */}
            <Launchpad />

            {/* Widget Modal (when a tile is chosen) */}
            <ModalWindow
                backdrop="static"
                keyboard={false}
                fullWidth={true}
                modal={widgetModalOpen}
                toggleModal={closeWidgetModal}
                modalHeader={modalTitle}
                modalBody={
                    <WidgetModalBody />
                }
            />

        </>
    );
};

export default WidgetDock;
